module.exports = __webpack_public_path__ + "img/main-list_03.9779cfbc.jpg";